module.exports = __webpack_public_path__ + "r-v3/img/btn_Sharing.e99d0254.svg";